var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.92C14.7394 11.92 16.96 9.69933 16.96 6.96C16.96 4.22067 14.7394 2 12 2C9.26071 2 7.04004 4.22067 7.04004 6.96C7.04004 9.69933 9.26071 11.92 12 11.92Z",
    fill: "#2B2B2B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 22C19.8635 22.0093 20.027 21.9832 20.1795 21.9236C20.332 21.864 20.4699 21.7723 20.5838 21.6546C20.6976 21.537 20.7848 21.3961 20.8394 21.2418C20.894 21.0874 20.9146 20.9231 20.9 20.76C20.26 17 16.52 14.11 12 14.11C7.48002 14.11 3.74002 17 3.10002 20.76C3.08539 20.9231 3.10607 21.0874 3.16064 21.2418C3.21521 21.3961 3.30239 21.537 3.41625 21.6546C3.53012 21.7723 3.66799 21.864 3.82049 21.9236C3.97299 21.9832 4.13654 22.0093 4.30002 22H19.7Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8255dff3aad9edd35ccdcd4597ab4af5.svg";
export { ForwardRef as ReactComponent };